// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"CanvasContainer_canvasContainer__1BEBD","goToHome":"CanvasContainer_goToHome__2FSKO"};